var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{staticStyle:{"font-size":"inherit"},attrs:{"icon":`${_vm.iconPack}:${_vm.iconData}`,"inline":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }